<template>
  <b-card
    :title="header"
    body-class="mx-3 mx-md-5 mx-lg-5 mx-xl-5 px-3 px-md-5 px-lg-5 px-xl-5"
    class="mt-5 p-0 p-md-5 p-lg-5 p-xl-5 w-75"
    style="/**width: 550px**/"
  >
    <b-form onkeydown="return event.key != 'Enter'">
      <p class="pb-2 grey--text">{{ subheader }}</p>

      <b-form-group
        id="input-group-password"
        label="Password"
        label-for="input-password"
        v-if="currentStep === 1"
      >
        <b-form-input
          id="input-password"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter password"
          :state="state.password"
          aria-describedby="input-password-feedback"
          @keyup.enter="nextStep"
        ></b-form-input>

        <b-form-invalid-feedback id="input-password-feedback">
          <!-- eslint-disable-next-line -->
          {{ errors.password }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        label="Email Address"
        label-for="input-email"
        v-else-if="currentStep === 2"
      >
        <b-form-input
          id="input-email"
          v-model="form.email"
          type="text"
          required
          placeholder="Enter email"
          :state="state.email"
          aria-describedby="input-email-feedback"
          @keyup.enter="nextStep"
        ></b-form-input>

        <b-form-invalid-feedback id="input-email-feedback">
          <!-- eslint-disable-next-line -->
          {{ errors.email }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-code" v-else>
        <code-input :loading="false" @complete="onCompleteCode" />

        <div class="invalid-feedback d-block mt-2">{{ errors.code }}</div>
      </b-form-group>

      <!-- <hr class="modal-divider mt-5" /> -->

      <!-- <div class="d-flex justify-content-between">
        <div class="w-100 mt-2 mb-1">
          <b-button
            variant="outline-secondary"
            class="w-25 mr-2 btn-outlined bg-white text-dark"
            :to="{ name: 'user.settings-page', hash: '#account' }"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="w-25 ml-2 float-right"
            :disabled="loading"
            @click="nextStep"
          >
            <b-spinner small v-if="loading"></b-spinner>&nbsp;Continue
          </b-button>
        </div>
      </div> -->
      <div class="justify-content-between">
        <b-container fluid>
          <b-row cols="2">
            <b-col
              cols="12"
              lg="6"
              xl="6"
              order="2"
              order-lg="1"
              order-xl="1"
              class="text-center text-lg-left text-xl-left"
            >
              <b-button
                class="w-75 mr-0 mr-lg-2 mr-xl-2 btn-outlined bg-white text-dark"
                variant="primary"
                :to="{ name: 'user.settings-page', hash: '#account' }"
              >
                Cancel
              </b-button>
            </b-col>
            <b-col
              cols="12"
              lg="6"
              xl="6"
              order="1"
              order-lg="2"
              order-xl="2"
              class="text-center text-lg-right text-xl-right"
            >
              <b-button
                variant="primary"
                class="w-75 ml-0 ml-lg-2 ml-xl-2"
                :disabled="loading"
                @click="nextStep"
              >
                <b-spinner small v-if="loading"></b-spinner>&nbsp;Continue
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CodeInput from '@/components/inputs/CodeInput'

export default {
  components: {
    CodeInput
  },

  computed: {
    ...mapState({
      verificationToken: state => state.auth.verificationToken,
      user: state => state.auth.user
    })
  },

  data() {
    return {
      loading: false,
      header: 'Verify Password',
      subheader: 'Enter your current password to change your email',
      currentStep: 1,
      form: {
        password: null,
        email: null,
        code: null
      },
      state: {
        password: null,
        email: null
      },
      errors: {
        password: null,
        email: null,
        code: null
      }
    }
  },

  methods: {
    ...mapActions({
      getVerificationToken: 'auth/getVerificationToken',
      requestChangeEmail: 'auth/requestChangeEmail',
      verifyChangeEmail: 'auth/verifyChangeEmail'
    }),

    nextStep() {
      if (this.currentStep === 1) {
        this.generateToken()
      }
      if (this.currentStep === 2) {
        this.changeEmailRequest()
      }
    },

    onCompleteCode(v) {
      this.form.code = v
      this.changeEmailVerify()
    },

    async generateToken() {
      this.loading = true
      await this.getVerificationToken({
        password: this.form.password
      })
        .then(() => {
          this.currentStep++
          this.header = 'New Email Address'
          this.subheader = 'Enter new email address'
        })
        .catch(error => {
          if (error.response.data) {
            this.state.password = false
            this.errors.password = error.response.data.message
          }
        })
      this.loading = false
    },

    async changeEmailRequest() {
      this.loading = true
      await this.requestChangeEmail({ email: this.form.email })
        .then(() => {
          this.currentStep++
          this.header = 'Verify Email'
          this.subheader = `Input the code sent to: ${this.form.email}`
        })
        .catch(error => {
          if (error.response.data) {
            this.state.email = false
            this.errors.email = error.response.data.message
          }
        })
      this.loading = false
    },

    async changeEmailVerify() {
      this.loading = true
      await this.verifyChangeEmail({
        token: this.form.code,
        email: this.form.email
      })
        .then(() => {
          this.$router.push({
            name: 'user.settings-page',
            hash: '#account'
          })
        })
        .catch(error => {
          if (error.response.data) {
            this.form.code = null
            this.errors.code = error.response.data.message
          }
        })
      this.loading = false
    }
  },

  watch: {
    'form.password'() {
      this.state.password = this.form.password.length !== 0 ? null : false
      this.errors.password = 'This field is required'
    },

    'form.email'() {
      this.state.email = this.form.email.length !== 0 ? null : false
      this.errors.email = 'This field is required'
    }
  },

  created() {
    this.header = this.user.has_password
      ? 'Verify Password'
      : 'New Email Address'
    this.subheader = this.user.has_password
      ? 'Enter your current password to change your email'
      : 'Enter new email address'
    this.currentStep = this.user.has_password ? 1 : 2
  }
}
</script>

<style scoped>
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}
</style>
